import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'binary-to-text',
  version: '1.0.0',
  properties: [
    {
      key: 'encoding',
      label: 'Encoding',
      type: 'options',
      default: 'utf-8',
      description: 'Character encoding to use when converting binary to text',
      options: [
        { value: 'utf-8', label: 'UTF-8 (Recommended)' },
        { value: 'utf-16', label: 'UTF-16 (Little Endian)' },
        { value: 'utf-16be', label: 'UTF-16 (Big Endian)' },
        { value: 'utf-32', label: 'UTF-32' },
        { value: 'ascii', label: 'ASCII' },
        { value: 'iso-8859-1', label: 'ISO-8859-1 (Latin-1)' },
        { value: 'windows-1252', label: 'Windows-1252' },
      ],
    },
    {
      key: 'binaryPropertyName',
      label: 'Binary Property Name',
      type: 'string',
      default: 'data',
      placeholder: 'data',
      description: 'The property name containing the binary data from the previous node',
    },
    {
      key: 'trimOutput',
      label: 'Trim Output',
      type: 'boolean',
      default: true,
      description: 'Remove leading and trailing whitespace from the converted text',
    },
    {
      key: 'removeBom',
      label: 'Remove BOM',
      type: 'boolean',
      default: true,
      description: 'Remove Byte Order Mark (BOM) character if present at the start of the text',
    },
  ],
};

export default schema;
